import { useEffect, useState } from "react";
import { UsersService } from "../../../services/users";
import { IOption } from "../../../types/Option";
import { getFormatted } from "../../../lib/PhoneFormatter";

export const useFetchUser = (
  userId: string | null,
  roles: IOption[],
  setHeaderTitleOnLoad: (item: any) => void
) => {
  const [user, setUser] = useState<any>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (userId) {
      setIsLoading(true);
      UsersService.fetchUser(userId)
        .then((res) => {
          setHeaderTitleOnLoad(res);

          const userData: any = { ...res };

          const initialRole = roles.find((item) => item.label === res.role);

          if (initialRole) {
            userData.roleId = initialRole.value;
          }

          if (res.phone) {
            userData.phone = getFormatted(res.phone).slice(2);
          }

          setUser(userData);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  }, [userId, setUser, setIsLoading, setHeaderTitleOnLoad, roles]);

  return { user, isLoading };
};
